export { AvatarPredictor } from './AvatarPredictor';
export * from './Avatar';
export * from './component/Avatar.component';
